export default "__VITE_ASSET__1bf19d2b__"